import { getAppLanguage } from "./getAppLanguage";

export const getLocalizedPath = (path) => {
  const currentLanguage = getAppLanguage();
  const langPrefix = currentLanguage?.key || "en";
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const hasLangPrefix = /^\/(en|ar)\//.test(cleanPath);
  if (hasLangPrefix) {
    return cleanPath;
  }
  return `/${langPrefix}${cleanPath}`;
};

